<mat-card class="row box-shadow">
  <mat-card-header>
    <mat-card-title class="col-12">
      <h3 class="col-12">Détails de la station</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <h4 class="col-12">
      {{station.name}}
    </h4>
    <label class="col-12">
      Adresse : {{station.street}} {{station.city}}
    </label>
  </mat-card-content>
  <mat-card-actions>
    <div class="col-12">
      <div class="row justify-content-center">
          <button class="col-8" (click)='displayLeafletDialog();' mat-stroked-button color="primary"><label>
              Afficher
              <mat-icon aria-hidden="false" aria-label="voir sur la carte">map</mat-icon>
            </label>
          </button>
      
      </div>
    </div>
  </mat-card-actions>
</mat-card>
